<div class="modal-body">
  <p class="centermodal__title mb-4">{{ 'documents.shareFolder.title' | translate: { folderName: folder?.name } }}</p>

  <app-switch-tabs name="context" [options]="tabOptions" inputWidth="100%" [(ngModel)]="context" [ngModelOptions]="{ standalone: true }" (ngModelChange)="searchShares(context)"></app-switch-tabs>

  @switch (context) {
    @case (ShareContext.People) {
      <div class="centermodal__group">
        <div class="centermodal__group-header">
          <p class="centermodal__group-title">{{ 'documents.shareFolder.peopleWithAccess' | translate }}</p>
          <button class="btn-S btn-outline icon-start" (click)="addSharing()">
            <i class="far fa-plus"></i>
            {{ 'button.add' | translate }}
          </button>
        </div>

        <app-search [(query)]="search" theme="clean" (queryChange)="searchShares(ShareContext.People)" #searchComponent></app-search>

        <ul class="centermodal__list">
          @for (share of searchedShares ?? folder.shares | filterUserSharesPipe; track $index) {
            <li class="centermodal__list-item">
              <div class="centermodal__list-main">
                <app-avatar [seed]="share?.user?.email || share?.user?.name || share?.user?.phone"></app-avatar>

                <div class="centermodal__list-content">
                  <span class="centermodal__list-name">{{ share.user?.name }}</span>
                  <span class="centermodal__list-email">{{ share.user?.email }}</span>
                </div>
              </div>

              <div class="d-flex">
                <div ngbDropdown placement="bottom-right">
                  <button class="btn-S btn-text icon-both" ngbDropdownToggle>
                    <i class="far fa-{{ share.role === FolderRoleEnum.Viewer ? 'eye' : 'pen-to-square' }}"></i>
                    {{ 'documents.shareFolder.' + (share.role | lowercase) | translate | lowercase }}
                    <i class="fas fa-caret-down"></i>
                  </button>

                  <div ngbDropdownMenu>
                    <button class="dropdown-item" ngbDropdownItem (click)="changeShareRole(share, FolderRoleEnum.Editor)">
                      {{ 'documents.shareFolder.editor' | translate }}
                    </button>

                    <button class="dropdown-item" ngbDropdownItem (click)="changeShareRole(share, FolderRoleEnum.Viewer)">
                      {{ 'documents.shareFolder.viewer' | translate }}
                    </button>
                  </div>
                </div>

                <div ngbDropdown placement="bottom-right">
                  <button class="btn-M btn-text icon-only" ngbDropdownToggle>
                    <i class="far fa-ellipsis-v"></i>
                  </button>

                  <div ngbDropdownMenu>
                    <button class="dropdown-item red" ngbDropdownItem (click)="removeShare(share)">
                      <i class="far fa-trash red"></i>
                      {{ 'button.remove' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </li>
          } @empty {
            <li class="centermodal__list-item data--empty">
              {{ 'documents.shareFolder.noUsers' | translate }}
            </li>
          }
        </ul>
      </div>
    }
    @case (ShareContext.Groups) {
      <div class="centermodal__group">
        <div class="centermodal__group-header">
          <p class="centermodal__group-title">{{ 'documents.shareFolder.groupsWithAccess' | translate }}</p>
          <button class="btn-S btn-outline icon-start" (click)="addSharing(true)">
            <i class="far fa-plus"></i>
            {{ 'button.add' | translate }}
          </button>
        </div>

        <app-search [(query)]="search" theme="clean" (queryChange)="searchShares(ShareContext.Groups)" #searchComponent></app-search>

        <ul class="centermodal__list">
          @for (share of searchedShares ?? folder.shares | filterGroupSharesPipe; track $index) {
            <li class="centermodal__list-item division--full">
              <div class="centermodal__list-main">
                <div class="centermodal__list-content">
                  <span class="centermodal__list-name">{{ share.group.name }}</span>
                </div>
              </div>

              <div class="d-flex">
                <div ngbDropdown placement="bottom-right">
                  <button class="btn-S btn-text icon-both" ngbDropdownToggle>
                    <i class="far fa-{{ share.role === FolderRoleEnum.Viewer ? 'eye' : 'pen-to-square' }}"></i>
                    {{ 'documents.shareFolder.' + (share.role | lowercase) | translate | lowercase }}
                    <i class="fas fa-caret-down"></i>
                  </button>

                  <div ngbDropdownMenu>
                    <button class="dropdown-item" ngbDropdownItem (click)="changeShareRole(share, FolderRoleEnum.Editor)">
                      {{ 'documents.shareFolder.editor' | translate }}
                    </button>

                    <button class="dropdown-item" ngbDropdownItem (click)="changeShareRole(share, FolderRoleEnum.Viewer)">
                      {{ 'documents.shareFolder.viewer' | translate }}
                    </button>
                  </div>
                </div>

                <div ngbDropdown placement="bottom-right">
                  <button class="btn-M btn-text icon-only" ngbDropdownToggle>
                    <i class="far fa-ellipsis-v"></i>
                  </button>

                  <div ngbDropdownMenu>
                    <button class="dropdown-item red" ngbDropdownItem (click)="removeShare(share)">
                      <i class="far fa-trash red"></i>
                      {{ 'button.remove' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </li>
          } @empty {
            <li class="centermodal__list-item data--empty">
              {{ 'documents.shareFolder.noGroups' | translate }}
            </li>
          }
        </ul>
      </div>
    }
    @case (ShareContext.Link) {
      <div class="centermodal__group">
        <div class="centermodal__group-header">
          <p class="centermodal__group-title">{{ 'documents.shareFolder.accessLink' | translate }}</p>

          @if (accessLink !== null) {
            <button class="btn-S btn-text-danger icon-start" (click)="updateAccessLink(true)">
              <i class="far fa-trash"></i>
              {{ 'documents.shareFolder.revoke' | translate }}
            </button>
          } @else {
            <button class="btn-S btn-outline icon-start" (click)="updateAccessLink()">
              <i class="far fa-plus"></i>
              {{ 'documents.shareFolder.newLink' | translate }}
            </button>
          }
        </div>

        @if (accessLink !== null) {
          <div class="access-link">
            <input type="text" class="access-link__input" [value]="accessLink" readonly #accessLinkInput />
            <button class="access-link__copy" (click)="copyAccessLink()" [ngxClipboard]="accessLinkInput">
              <i class="fal fa-clone"></i>
            </button>
          </div>

          <hr />

          <form class="centermodal__form" [formGroup]="linkForm" novalidate>
            <div class="require-password">
              <div class="sidemodal__switch my-2">
                <app-switch formControlName="requirePassword" (change)="isPasswordRequired = $event"></app-switch>
                <span class="sidemodal__switch-name">{{ 'documents.shareFolder.requirePassword' | translate }}</span>
              </div>

              @if (linkForm.get('requirePassword').value) {
                <label class="field__holder field__holder-small" [appFormControlWrap]="linkForm.get('password')">
                  <input
                    type="text"
                    class="field field--password"
                    [class.password_edit]="folder.has_password"
                    autocomplete="none"
                    minlength="8"
                    maxlength="255"
                    formControlName="password"
                    [required]="isPasswordRequired"
                    [placeholder]="folder.has_password ? 'password' : ''"
                  />
                  <span class="field__placeholder">{{ 'auth.password' | translate }}</span>
                </label>
              }
            </div>
          </form>
        } @else {
          <span class="data--empty d-flex mx-auto">{{ 'documents.shareFolder.noLink' | translate }}</span>
        }
      </div>
    }
  }

  <div class="centermodal__button-group">
    <button class="btn-M btn-filled-cancel" (click)="modal.dismiss()">{{ 'button.close' | translate }}</button>
    @if (context === ShareContext.Link && !!accessLink) {
      <button class="btn-M btn-filled" (click)="updateFolderPassword()">{{ 'button.save' | translate }}</button>
    }
  </div>
</div>
